
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RewardsRoutingModule } from './rewards-routing.module';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { RewardsComponent } from './rewards.component';
import { SharedModule } from '../shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    SharedModule,
    RewardsRoutingModule,
    RouterModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ChildHeaderModule,
    MatProgressSpinnerModule,
    BreadcrumbModule
  ],
  declarations: [
    RewardsComponent
  ]
})
export class RewardsModule { }
